<ds-card-header surface="lowest" msThemedCardHeader [title]="title || ''" [themedSurface]="themeHeaderSurface">
    @if (titleIcon && fallbackIcon) {
        <div class="title-icon" slot="start">
            @if (titleLogo && leagueId) {
                <ms-competition-logo class="icon" [sportId]="sportId" [leagueId]="leagueId" [fallbackIcon]="fallbackIcon" />
            } @else if (fallbackIcon) {
                <span class="icon {{ fallbackIcon }}"></span>
            }
        </div>
    }
    @if (customHeaderIcon) {
        <img class="custom-icon" width="24" height="24" priority alt="header-logo" slot="start" [ngSrc]="customHeaderIcon" />
    }

    @if (linkConfig && linkConfig.link && (linkConfig.linkText || linkConfig.disableLinkTextAndClick)) {
        <div class="globalLink" slot="title">
            <ms-item [href]="linkConfig.link" [tracking]="undefined" (click)="!linkConfig.disableLinkTextAndClick && linkClicked()">
                @if (linkConfig.linkText && !linkConfig.disableLinkTextAndClick) {
                    <span item-title [innerHtml]="linkConfig.linkText | msTrust: 'html'"></span>
                }
            </ms-item>
        </div>
    }
    @if (headerChevronLink) {
        <span class="header-navigation-chevron" slot="title">
            <vn-icon name="theme-right" size="14" />
        </span>
    }
    <ng-content />
</ds-card-header>
